export enum Permission {
  ShiftsView = 'partner_pick.view',
  ShiftsModify = 'partner_pick.modify',
  WarehouseLocationHoursView = 'warehouse_location_hours.view',
  ShiftsViewLegacy = 'shifts_view.legacy_permission',
  DeliveryRouteView = 'partner_bulk_delivery_route.view',
}
